module.exports = __webpack_public_path__ + "static/media/checkboxInstall4.e5885859.svg";